import apiClient from "../config/apiClient";


export const fetchInsurance = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=hmos/transactions?page=1%26limit=15%26patient_id=${id}%26startDate=%26endDate=%26status=0%26hmo_id=%26service_id=%26admission_status=%26is_opd=0`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };

     // http://178.128.249.42:92/hmos/transactions?page=1&limit=15&patient_id=&startDate=&endDate=&status=0&hmo_id=&service_id=&admission_status=&is_opd=0